import { render, staticRenderFns } from "./AgingStock.vue?vue&type=template&id=456cf120&scoped=true"
import script from "./AgingStock.vue?vue&type=script&lang=js"
export * from "./AgingStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cf120",
  null
  
)

export default component.exports